import styled from 'styled-components'
import { palette } from '../../Styles/colors'
import { media } from '../../Styles/media'

const Container = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${palette.base}
  box-shadow: 0px -5px 5px rgba(0,0,0,0.3);

  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;

  ${media.tablet`
    justify-content: flex-end;
  `}
`

const Close = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  a.img-anchor {
    line-height: 0;
    display: block;
    width: calc(100% * (1/3) - 1em - 1px);
  }

  svg {

  }

  p {
    font-size: 1em;
    margin: 0.7em 0 0 0;
  }

  ${media.tablet`
    width: calc(100% * (1/5) - 1em - 1px) !important;
    p { font-size: 0.6em; }
  `}

  ${media.desktop`
    width: calc(17% * (1/1) - 1em - 1px) !important;
    p { font-size: 0.6em; }
  `}
`

export { Container, Close }



// WEBPACK FOOTER //
// ./src/Components/Navigation/styles.js